var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "training-panel" },
    [
      _c("IconButton", { attrs: { "on-click": _vm.showAIKnowledgeClick } }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("auto_awesome")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }